import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiService } from '../../../web-services/api/api.service';

@Component({
  selector: 'app-reset-password-modal',
  imports: [TranslatePipe,RTLDivDirectiveDirective,FormsModule,CommonModule],
  templateUrl: './reset-password-modal.html',
  styleUrl: './reset-password-modal.scss',
})
export class ResetPasswordModal {
  isEmpty: boolean;
  emailValidation: boolean;
  email:any;
  resetEmail: string;
  submit: boolean = false;
  showResetApproval: boolean = false;
	@Output() showHideResetModal = new EventEmitter<any>();
	@Output() showHideSuccessModal = new EventEmitter<any>();

  constructor(private apiService:ApiService) { }

  ngOnInit() {
    this.resetEmail = "";
	}
	
	public closeModal = () => {
    this.resetEmail = "";
		if (this.showResetApproval) {
			this.showResetApproval = false;
			return;
		}
    this.submit = false;
		this.showHideResetModal.emit(false);
  }
  
  public sendEmail = (email: string) => {
    if (email.length === 0)
      this.isEmpty = true;
    this.submit = true;
    if (this.emailValidation){
      const emailToReset = {
        "email_address": email
      }
      this.apiService.forgotMyPassword(emailToReset);
      this.resetEmail = "";
      this.showHideResetModal.emit(false);
      this.showHideSuccessModal.emit(true);
      
    }
  }
  public validateEmail = (event) => {
    const patt = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+/;
    this.emailValidation = patt.test(event.value);
  }
}
